import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import ClientCache from "@/utils/login/ClientCache.ts";
import AGGridTranslatorColumn from "@/utils/UIConstants/AGGridColumns/AGGridTranslatorColumn.ts";
import AGGridFormatterBasedColumn from "@/utils/UIConstants/AGGridColumns/AGGridFormatterBasedColumn.ts";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";

export default class AGGridTextColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = this.cellRenderer();
    return colDef;
  }

  private cellRenderer(): any {
    let cr;
    if (ClientCache.doesFieldHaveAllowedValues(this.entityType, this.column.id!)) {
      let cellRenderer = new AGGridTranslatorColumn(this.column, this.entityType).createColDef({}).cellRenderer;
      if (cellRenderer && typeof cellRenderer === "function")
        cr = cellRenderer;
    } else {
      let cellRenderer = new AGGridFormatterBasedColumn(this.column, this.entityType).createColDef({}).cellRenderer;
      if (cellRenderer && typeof cellRenderer === "function")
        cr = cellRenderer;
    }
    return (params: ICellRendererParams) => {
      if (cr)
        return cr(params);
      return params.value;
    }
  }
}
